import React from 'react';
import {FormattedMessage} from 'react-intl';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import {usePaymentCreditCardContext} from '../../contexts/PaymentCreditCardContex';
import styles from './ButtonSubmitCreditCard.module.scss';

const ButtonSubmitCreditCard = () => {
  const {loading} = usePaymentCreditCardContext();

  return (
    <div className={styles.buttonSubmitContainer}>
      <ButtonAction
        variant={'button'}
        type={'submit'}
        label={(
          <FormattedMessage
            id={'payment-form-submitBtn'}
            defaultMessage={'Create link'}
          />
        )}
        customClassnames={{container: styles.button}}
        disabled={loading}
      />
    </div>
  );
};

export default ButtonSubmitCreditCard;
